import { formatLicensePlateForDisplay } from "@/lib/licensePlate";

export const VEHICLE_TYPES = [
  { value: "caravan", label: "Wohnwagen" },
  { value: "motorhome", label: "Wohnmobil" },
  { value: "car", label: "PKW" },
  { value: "trailer", label: "Anhänger" },
  { value: "tent_car", label: "Zelt mit Auto" },
  { value: "other", label: "Sonstiges" },
] as const;

export type VehicleTypeValue = (typeof VEHICLE_TYPES)[number]["value"];

export function vehicleTypeLabel(value: string | null | undefined): string {
  if (!value) return "—";
  return VEHICLE_TYPES.find((t) => t.value === value)?.label ?? value;
}

/** Anzeige-Kennzeichen: optional Länderkürzel, lesbares Format AB-C 1234. */
export function formatLicensePlate(
  plate: string | null | undefined,
  country: string | null | undefined,
): string {
  if (!plate?.trim()) return "—";
  const p = formatLicensePlateForDisplay(plate);
  if (country?.trim()) return `${country.trim().toUpperCase()} · ${p}`;
  return p;
}
